<script lang="ts">
	//Design system components
	import { Text, Container } from '@Shelly/shelly-design-system';

	//Components
	import DayPicker from '../../../../../components/TimePicker/DayPicker.svelte';

	//Services
	import { format } from 'svelte-i18n';

	export let editableObject;

	let days = editableObject.days;
	const changeDays = (e) => {
		editableObject.days = e.detail;
	};
</script>

<Container padding="scrollPaddings">
	<Text class="mb-s" element="h2">{$format('choose_weekday')}</Text>
	<DayPicker {days} on:change={changeDays} />
</Container>
